// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import InputRange from '../dashboard/inputRange';
import DashboardIcon from '../dashboard/icons/DashboardIcon';

const AdminContractorSearch = ({ onSearch, showRange = true }) => {
  const [search, setSearch] = useState('');
  const [searchZip, setSearchZip] = useState('');
  const [range, setRange] = useState(60);

  const handleSubmit = (event) => {
    event.preventDefault();
    onSearch({
      search,
      search_zip: searchZip,
      ...(showRange ? { range } : {}),
    });
  };

  return (
    <form className="subpage-filters subpage-filters--contractors" onSubmit={handleSubmit}>
      <input
        type="text"
        className="dashboard-input subpage-filters__search"
        name="search"
        maxLength={50}
        aria-label="search contractors"
        placeholder="Search name, email, or contractor ID"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <input
        type="text"
        className="dashboard-input subpage-filters__zip"
        name="search_zip"
        maxLength={8}
        aria-label="zip code"
        placeholder="Zip code"
        value={searchZip}
        onChange={(e) => setSearchZip(e.target.value)}
      />
      {showRange && (
        <InputRange
          defaultValue={range}
          handler={setRange}
          className="subpage-contractors-range"
        />
      )}
      <button type="submit" className="subpage-btn subpage-btn--gold subpage-filters__submit" aria-label="search">
        <DashboardIcon name="search" size={18} strokeWidth="2.5" />
        Search
      </button>
    </form>
  );
};

export default AdminContractorSearch;
